import { AxiosResponse } from "axios";
import {getFile} from "../api/files";

export const downloadFile = async (
	fileId: number,
	fileName: string
): Promise<void> => {
	try {
		const { data }: AxiosResponse<Blob> = await getFile(fileId);

		if (!(data instanceof Blob)) return;

		const url = URL.createObjectURL(data);
		const link = document.createElement("a");

		link.href = url;
		link.download = fileName;

		document.body.appendChild(link);
		link.click();

		link.remove();
		URL.revokeObjectURL(url);
	} catch (err) {
		console.error("Не удалось скачать файл:", err);
	}
};
